import { useTranslation } from "react-i18next";
import { VirtualAccountDetailsProps } from "../types";
import { PriceRow } from "./PriceRow";
import { VirtualAccountInfo } from "./VirtualAccountInfo";

import moment from "moment";
import { ViewYmdFormat } from "src/utils/common-util";

// 가상계좌 상세 정보 컴포넌트
// 결제 금액 정보와 가상계좌 정보를 표시하는 컴포넌트
export const VirtualAccountDetails = ({ payment, documentProofRequest, billPayStatus, receiptBundle, onCopyAccount }: VirtualAccountDetailsProps) => {
  const { t } = useTranslation("contract");
  // 결제 성공 여부 확인
  const isPaymentSuccess = billPayStatus === "PAYMENT_SUCCESS";

  return (
    <>
      {/* 상품 금액 정보 표시 */}
      <PriceRow label={t("detail.productAmount")} value={payment.totalAmount - payment.taxAmount} />
      <PriceRow label={t("detail.vat")} value={payment.taxAmount} />
      <PriceRow label={t("detail.totalPaymentAmount")} value={payment.totalAmount} isTotal />

      {/* 가상계좌 정보 표시 */}
      {payment.virtualAccount && (
        <VirtualAccountInfo
          payment={payment}
          documentProofRequest={documentProofRequest}
          virtualAccount={payment.virtualAccount}
          billPayStatus={billPayStatus}
          onCopyAccount={onCopyAccount}
        />
      )}

      {/* 결제 성공 시 계좌번호와 결제일시 표시 */}
      {isPaymentSuccess && receiptBundle?.lastTrDateTime && (
        <>
          <div className="base-section-layout-line">
            <p className="base-section-layout-index text-primary3">{t("detail.accountNumber")}</p>
            <p
              className="base-section-layout-value text-underline cursor-pointer"
              onClick={() => onCopyAccount(String(payment?.virtualAccount?.accountNo))}
            >
              {payment?.virtualAccount?.bankName} {payment?.virtualAccount?.accountNo}
            </p>
          </div>
          <div className="base-section-layout-line">
            <p className="base-section-layout-index text-primary3">{t("detail.paymentDate")}</p>
            <p className="base-section-layout-value">{moment(receiptBundle?.lastTrDateTime).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM)}</p>
          </div>
        </>
      )}
    </>
  );
};
